
function GstDetails() {
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                <div class="col-xxl-2"></div>
                    <div class="col-xxl-8">
                        <div class="card">
                            

                            <div class="card-body">
                                <h5>Pharmacy Profile</h5>
                                <br/>
                                <div class="live-preview">
                                    <form action="javascript:void(0);">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Pharmacy Name </label>
                                                    <input type="text" class="form-control" placeholder="Enter your Pharmacy Name" id="firstNameinput"/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="lastNameinput" class="form-label">Ownwer Name</label>
                                                    <input type="text" class="form-control" placeholder="Enter your Ownwer Name" id="lastNameinput"/>
                                                </div>
                                            </div>
                                           
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">DL. NO.</label>
                                                    <input type="text" class="form-control" placeholder="Enter DL. NO." id="compnayNameinput"/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Phone No</label>
                                                    <input type="tel" class="form-control" placeholder="Phone No" id="phonenumberInput"/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Upload Header</label>
                                                    <input type="file" class="form-control" placeholder="Phone 2" id="phonenumberInput"/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Upload Footer</label>
                                                    <input type="file" class="form-control" placeholder="Phone 2" id="phonenumberInput"/>
                                                </div>
                                            </div>
                                           
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                    </div> 
                    <div class="col-xxl-2"></div>
                </div>
            </div>
        </div>
    );
}

export default GstDetails;
